/**
Specifies the folders that different file types belong to.
*/
export enum ProjectFolder {
  Root = '',
  Content = 'Content',
  Topics = 'Content',
  Projects = 'Project',
  ConditionTagSets = 'Project/ConditionTagSets',
  VariableSets = 'Project/VariableSets',
  Targets = 'Project/Targets',
  TOCs = 'Project/TOCs',
  Skins = 'Project/Skins',
  Destinations = 'Project/Destinations',
  Snippets = 'Content/Resources/Snippets',
  Templates = 'Content/Resources/TemplatePages',
  Images = 'Content/Resources/Images',
  Multimedia = 'Content/Resources/Multimedia',
  Stylesheet = 'Content/Resources/Stylesheets',
  BrandingStylesheet = 'Content/Resources/Branding',
}
